import React from "react";

const Main = React.lazy(() => import("../pages/Main/Main"));
const Login = React.lazy(() => import("../pages/Auth/Login"));
const Register = React.lazy(() => import("../pages/Auth/Register"));
const Restore = React.lazy(() => import("../pages/Auth/Restore"));

const Room = React.lazy(() => import("../pages/Room/Room"));
const Card = React.lazy(() => import("../pages/Room/Card/Card"));
const PaymentTuition = React.lazy(() =>
  import("../pages/Room/tuition-payment/PaymentTuition")
);
const Credit = React.lazy(() => import("../pages/Room/Credit/Credit"));
const Document = React.lazy(() => import("../pages/Room/Document/Document"));
const PasswordChange = React.lazy(() =>
  import("../pages/Room/PasswordChange/PasswordChange")
);
const Feedback = React.lazy(() => import("../pages/Room/Feedback"));
const Reception = React.lazy(() => import("../pages/Room/Reception"));
const Profile = React.lazy(() => import("../pages/Room/Profile"));
const ProfileEdit = React.lazy(() => import("../pages/Room/Profile/edit"));
const ProfileAddMore = React.lazy(() =>
  import("../pages/Room/Profile/add-more")
);
const CardAgreement = React.lazy(() =>
  import("../pages/Main/agreements/card-agreement")
);
const DocumentAgreement = React.lazy(() =>
  import("../pages/Main/agreements/document-agreement")
);
const CreditAgreement = React.lazy(() =>
  import("../pages/Main/agreements/credit-agreement")
);
const PaymentAgreement = React.lazy(() =>
  import("../pages/Main/agreements/payment-agreement")
);

const ForeignStudent = React.lazy(() => import("../pages/Room/ForeignStudent"));

export const RoutesNames = {
  INDEX: "/",
  LOGIN: "/online/auth/login",
  // REGISTER: "/online/auth/register",
  RESTORE: "/online/password/reset/:token",
  CREDIT: "/online/room/credit",
  CARD: "/online/room/card",
  TUITIONPAYMENT: "/online/room/tuition-payment",
  DOCUMENT: "/online/room/document",
  // FEEDBACK: "/online/room/feedback",
  // RECEPTION: "/online/room/reception",
  PROFILE: "/online/room/profile",
  PROFILEEDIT: "/online/room/profile/edit",
  PROFILEADDMORE: "/online/room/profile/add-more",
  // CHANGEPASSWORD: "/online/room/change-password",
  ROOM: "/online/room",
  FOREIGNSTUDENT: "/online/foreign-student",
  CARDAGREEMENT: "/online/agreements/card-agreement",
  DOCUMENTAGREEMENT: "/online/agreements/document-agreement",
  CREDITAGREEMENT: "/online/agreements/credit-agreement",
  PAYMENTAGREEMENT: "/online/agreements/payment-agreement",
};

export const publicRoutes = [
  {
    path: RoutesNames.INDEX,
    index: false,
    component: <Main />,
  },
  {
    path: RoutesNames.LOGIN,
    index: false,
    component: <Login />,
  },
  {
    path: RoutesNames.REGISTER,
    index: false,
    component: <Register />,
  },
  {
    path: RoutesNames.RESTORE,
    index: false,
    component: <Restore />,
  },

  {
    path: RoutesNames.CARDAGREEMENT,
    title: "Card agreement",
    index: false,
    component: <CardAgreement />,
  },

  {
    path: RoutesNames.DOCUMENTAGREEMENT,
    title: "Document agreement",
    index: false,
    component: <DocumentAgreement />,
  },
  {
    path: RoutesNames.PAYMENTAGREEMENT,
    title: "Payment agreement",
    index: false,
    component: <PaymentAgreement />,
  },
  {
    path: RoutesNames.CREDITAGREEMENT,
    title: "Credit agreement",
    index: false,
    component: <CreditAgreement />,
  },

  // {
  //     path:'*',
  //     index:false,
  //     component: <Navigate to={RoutesNames.INDEX} replace/>
  // }
];

export const userRoutes = [
  {
    path: RoutesNames.CARD,
    title: "Kart bölümi",
    index: false,
    component: <Card />,
  },
  {
    path: RoutesNames.TUITIONPAYMENT,
    title: "PaymentForeignStudent",
    index: false,
    component: <PaymentTuition />,
  },
  {
    path: RoutesNames.CREDIT,
    title: "Karz bölümi",
    index: false,
    component: <Credit />,
  },
  {
    path: RoutesNames.DOCUMENT,
    title: "Güwanama bölümi",
    index: false,
    component: <Document />,
  },
  {
    path: RoutesNames.ROOM,
    title: "Baş sahypa",
    index: false,
    component: <Room />,
  },

  // {
  //   path: RoutesNames.CHANGEPASSWORD,
  //   title: "Gizin acary calyshmak",
  //   index: false,
  //   component: <PasswordChange />,
  // },
  // {
  //   path: RoutesNames.FEEDBACK,
  //   title: "Arz shikayat",
  //   index: false,
  //   component: <Feedback />,
  // },
  // {
  //   path: RoutesNames.RECEPTION,
  //   title: "Online kabulhana",
  //   index: false,
  //   component: <Reception />,
  // },
  {
    path: RoutesNames.RECEPTION,
    title: "Online kabulhana",
    index: false,
    component: <Reception />,
  },
  {
    path: RoutesNames.PROFILE,
    index: false,
    component: <Profile />,
  },
  {
    title: "Profile",
    path: RoutesNames.PROFILEEDIT,
    // title: "ProfileEdit",
    index: false,
    component: <ProfileEdit />,
  },
  {
    title: "ProfileAddMore",
    path: RoutesNames.PROFILEADDMORE,
    index: false,
    component: <ProfileAddMore />,
  },
  // {
  //   title: "ForeignStudent",
  //   path: RoutesNames.FOREIGNSTUDENT,
  //   title: "ForeignStudent",
  //   index: false,
  //   component: <ForeignStudent />,
  // },

  // {
  //     path:'*',
  //     index:false,
  //     component: <Navigate to={RoutesNames.ROOM} replace/>
  // }
];
